import React, { useState } from "react";
import { ChevronDown, Search } from "lucide-react";
import { Input } from "@/components/ui/input";

interface MobileFilterBarProps {
  statusValue: "all" | "pending" | "accepted" | "declined";
  onStatusChange?: (
    status: "all" | "pending" | "accepted" | "declined"
  ) => void;
  onSearchChange?: (searchTerm: string) => void;
}

export default function MobileFilterBar({
  statusValue,
  onStatusChange,
  onSearchChange,
}: MobileFilterBarProps) {
  const [localSearch, setLocalSearch] = useState("");

  const handleStatusChange = (
    value: "all" | "pending" | "accepted" | "declined"
  ) => {
    onStatusChange?.(value);
  };

  const handleSearchChange = (value: string) => {
    setLocalSearch(value);
    onSearchChange?.(value);
  };

  return (
    <div className="bg-white px-4 py-3">
      {/* Horizontal Layout: Status Filter & Search */}
      <div className="flex items-center gap-2">
        {/* Status Filter */}
        <div className="flex items-center gap-1">
          <span className="text-sm text-gray-600 whitespace-nowrap">
            Status:
          </span>
          <div className="relative">
            <select
              value={statusValue}
              onChange={(e) =>
                handleStatusChange(
                  e.target.value as "all" | "pending" | "accepted" | "declined"
                )
              }
              className="appearance-none bg-transparent pr-5 text-sm text-gray-900 font-medium focus:outline-none border-0"
            >
              <option value="all">All</option>
              <option value="pending">Pending</option>
              <option value="accepted">Accepted</option>
              <option value="declined">Declined</option>
            </select>
            <ChevronDown className="absolute right-0 top-1/2 transform -translate-y-1/2 w-3 h-3 text-gray-400 pointer-events-none" />
          </div>
        </div>

        {/* Search Input */}
        <div className="flex-1 relative">
          <Search className="absolute left-2 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" />
          <Input
            placeholder="Search"
            className="pl-7 pr-3 bg-gray-50 border-0 rounded-lg text-sm h-8"
            value={localSearch}
            onChange={(e) => handleSearchChange(e.target.value)}
          />
        </div>
      </div>
    </div>
  );
}
